import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const {user} = useAuth()

  if (!user) {
    console.log("checking")
    return <Navigate to='/' />;
  } else {
    console.log("checking failes")
    return children;
  }
};

export default ProtectedRoute;